export enum Roles {
  Admin = 'Admin',
  Supervisor = 'Supervisor',
  TerritoryManager = 'TerritoryManager',
  User = 'User',
}
